import React from "react";
import styles from "./Footer.module.css";
import { NavBtn } from "../Buttons/NavBtn/NavBtn";
import { SocialIcons } from "../Icons/Icons";
import { HoverText } from "../HoverText/HoverText";

import logo from "../assets/logo/pawCircle.svg";
import {
  BsInstagram,
  BsFacebook,
  BsPinterest,
  BsMailbox,
  // BsShop,
} from "react-icons/bs";

function Footer({
  inicio,
  gallery,
  galleryAmigurumis,
  galleryAnime,
  galleryChenille,
  galleryKeychain,
  galleryRandom,
  aboutMe,
  contact,
  faq,
}) {
  const [showText, setShowText] = React.useState(false);

  return (
    <div id="#footer" className={styles.section}>
      <NavBtn
        style={{ gridColumn: "2/4" }}
        btnStyle={{
          transform: "translate(20%, -30%)",
        }}
        logo={logo}
        flex={{ flexDirection: "column", marginTop: "2rem", gridColumn: "4/5" }}
        size={{ height: "10rem", width: "10rem" }}
        inicio={inicio}
        gallery={gallery}
        galleryAmigurumis={galleryAmigurumis}
        galleryAnime={galleryAnime}
        galleryChenille={galleryChenille}
        galleryKeychain={galleryKeychain}
        galleryRandom={galleryRandom}
        aboutMe={aboutMe}
        contact={contact}
        faq={faq}
      ></NavBtn>
      <div
        className={styles.shop}
        onMouseMove={() => setShowText(true)}
        onMouseLeave={() => setShowText(false)}
      >
        {showText && (
          <HoverText>
            Estamos trabajando en la tienda. Disculpe las molestias.{" "}
          </HoverText>
        )}
        {/* <p className={styles.text}>Visitá mi tienda online </p>{" "}
        <BsShop className={styles.icon}></BsShop> */}
      </div>
      <div className={styles.social}>
        <SocialIcons
          href="https://www.instagram.com/pawpawneedle/"
          icon={<BsInstagram></BsInstagram>}
        ></SocialIcons>
        <SocialIcons
          href="https://www.facebook.com/pawpawneedle"
          icon={<BsFacebook></BsFacebook>}
        ></SocialIcons>
        <SocialIcons
          href="mailto:pawpawneedle@gmail.com"
          icon={<BsMailbox></BsMailbox>}
        ></SocialIcons>
        <SocialIcons
          href="https://pin.it/2aEu7Se"
          icon={<BsPinterest></BsPinterest>}
        ></SocialIcons>
      </div>
      <p className={styles.copyright}>Creado por Guadalupe D. Escobar</p>
    </div>
  );
}

export { Footer };
